<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
                 :fullscreen="false"
    >
        <pedido-cuenta-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import PedidoCuentaProvider from "../../../../providers/PedidoCuentaProvider";

    import {CrudCreate, ClientError} from '@dracul/common-frontend'

    import PedidoCuentaForm from "../PedidoCuentaForm";




    export default {
        name: "PedidoCuentaCreate",

        components: { PedidoCuentaForm, CrudCreate },

        props:{
          open: {type: Boolean, default: true}
        },

        data() {
            return {
                title: 'cobrox.pedidoCuenta.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    cuil: '',
                    agenciaSolicitante: null,
                    comentarioSolicitante: null,
                    agenciaAutorizante: null,
                    creadoPor: null,
                    estadoPedidoCuenta: 'PENDIENTE'
                }
            }
        },

        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    PedidoCuentaProvider.createPedidoCuenta(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createPedidoCuenta)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

